export default {
  "PHB": "Player's Handbook (2014)",
  "MM": "Monster Manual (2014)",
  "DMG": "Dungeon Master's Guide (2014)",
  "Screen": "Dungeon Master's Screen",
  "SCAG": "Sword Coast Adventurer's Guide",
  "PS-Z": "Plane Shift: Zendikar",
  "PS-I": "Plane Shift: Innistrad",
  "AL": "Adventurers League",
  "VGM": "Volo's Guide to Monsters",
  "PS-K": "Plane Shift: Kaladesh",
  "PS-A": "Plane Shift: Amonkhet",
  "OGA": "One Grung Above",
  "XGE": "Xanathar's Guide to Everything",
  "PS-X": "Plane Shift: Ixalan",
  "MTF": "Mordenkainen's Tome of Foes",
  "PS-D": "Plane Shift: Dominaria",
  "GGR": "Guildmasters' Guide to Ravnica",
  "SAC": "Sage Advice Compendium",
  "AI": "Acquisitions Incorporated",
  "RMR": "Dungeons & Dragons vs. Rick and Morty: Basic Rules",
  "ERLW": "Eberron: Rising from the Last War",
  "EGW": "Explorer's Guide to Wildemount",
  "MOT": "Mythic Odysseys of Theros",
  "ScreenDungeonKit": "Dungeon Master's Screen: Dungeon Kit",
  "HF": "Heroes' Feast",
  "ScreenWildernessKit": "Dungeon Master's Screen: Wilderness Kit",
  "TCE": "Tasha's Cauldron of Everything",
  "VRGR": "Van Richten's Guide to Ravenloft",
  "DoD": "Domains of Delight",
  "MaBJoV": "Minsc and Boo's Journal of Villainy",
  "FTD": "Fizban's Treasury of Dragons",
  "SCC": "Strixhaven: A Curriculum of Chaos",
  "TDCSR": "Tal'Dorei Campaign Setting Reborn",
  "MPMM": "Mordenkainen Presents: Monsters of the Multiverse",
  "TD": "Tarot Deck",
  "AAG": "Astral Adventurer's Guide",
  "BAM": "Boo's Astral Menagerie",
  "ScreenSpelljammer": "Dungeon Master's Screen: Spelljammer",
  "HAT-TG": "Thieves' Gallery",
  "BGG": "Bigby Presents: Glory of the Giants",
  "MCV4EC": "Monstrous Compendium Volume 4: Eldraine Creatures",
  "MPP": "Morte's Planar Parade",
  "SatO": "Sigil and the Outlands",
  "AATM": "Adventure Atlas: The Mortuary",
  "HFFotM": "Heroes' Feast Flavors of the Multiverse",
  "BMT": "The Book of Many Things",
  "DMTCRG": "The Deck of Many Things: Card Reference Guide",
  "PaF": "Puncheons and Flagons",
  "XPHB": "Player's Handbook (2024)",
  "XDMG": "Dungeon Master's Guide (2024)",
  "XScreen": "Dungeon Master's Screen (2024)",
  "XMM": "Monster Manual (2025)",
  "BGDIA": "Baldur's Gate: Descent into Avernus",
  "ToA": "Tomb of Annihilation",
  "WDH": "Waterdeep: Dragon Heist",
  "WDMM": "Waterdeep: Dungeon of the Mad Mage",
  "DSotDQ": "Dragonlance: Shadow of the Dragon Queen",
  "VEoR": "Vecna: Eve of Ruin",
  "PotA": "Princes of the Apocalypse",
  "SKT": "Storm King's Thunder",
  "QftIS": "Quests from the Infinite Staircase",
  "CRCotN": "Critical Role: Call of the Netherdeep",
  "IDRotF": "Icewind Dale: Rime of the Frostmaiden",
  "GoS": "Ghosts of Saltmarsh",
  "LoX": "Light of Xaryxis",
  "LMoP": "Lost Mine of Phandelver",
  "OotA": "Out of the Abyss",
  "HotDQ": "Hoard of the Dragon Queen",
  "PaBTSO": "Phandelver and Below: The Shattered Obelisk",
  "AITFR": "Adventures in the Forgotten Realms",
  "AitFR-DN": "Adventures in the Forgotten Realms: Deepest Night",
  "AitFR-FCD": "Adventures in the Forgotten Realms: From Cyan Depths",
  "AitFR-ISF": "Adventures in the Forgotten Realms: In Scarlet Flames",
  "AitFR-THP": "Adventures in the Forgotten Realms: The Hidden Page",
  "AiTFR:ISF": "Adventures in the Forgotten Realms: In Scarlet Flames",
  "ALCurseOfStrahd": "Adventurers League: Curse of Strahd",
  "ALElementalEvil": "Adventurers League: Elemental Evil",
  "ALRageOfDemons": "Adventurers League: Rage of Demons",
  "AWM": "Adventuring with Muk",
  "CM": "Candlekeep Mysteries",
  "COA": "Chains of Asmodeus",
  "CoA": "Chains of Asmodeus",
  "CoS": "Curse of Strahd",
  "DC": "Divine Contention",
  "DIP": "Dragon of Icespire Peak",
  "DL": "Dragonlance Setting",
  "DitLCoT": "Descent into the Lost Caverns of Tsojcanth",
  "DoSI": "Dragons of Stormwreck Isle",
  "E:RftLW": "Eberron: Rising from the Last War",
  "ELW": "Embers of the Last War",
  "FR": "Forgotten Realms",
  "FToD": "Fizban's Treasury of Dragons",
  "Generic": "Generic",
  "HftT": "Hunt for the Thessalhydra",
  "IMR": "Infernal Machine Rebuild",
  "Ixalan": "Ixalan",
  "JttRC": "Journeys through the Radiant Citadel",
  "KftGV": "Keys from the Golden Vault",
  "LR": "Locathah Rising",
  "MABJOV": "Minsc and Boo's Journal of Villainy",
  "MCV1SC": "Monstrous Compendium Volume 1: Spelljammer Creatures",
  "MCV2DC": "Monstrous Compendium Volume 2: Dragonlance Creatures",
  "MCV3MC": "Monstrous Compendium Volume 3: Minecraft Creatures",
  "MCv3MC": "Monstrous Compendium Volume 3: Minecraft Creatures",
  "MFF": "Mordenkainen's Fiendish Folio Volume 1",
  "MGELFT": "Muk's Guide To Everything He Learned From Tasha",
  "MM,": "Monster Manual",
  "MToF": "Mordenkainen's Tome of Foes",
  "MisMV1": "Misplace Monsters Volume 1",
  "OOW": "Of Ships and the Sea",
  "OoW": "Of Ships and the Sea",
  "POTA": "Princes of the Apocalypse",
  "PS:A": "Plane Shift: Amonkhet",
  "PS:D": "Plane Shift: Dominaria",
  "PSA": "Plane Shift: Amonkhet",
  "PSD": "Plane Shift: Dominaria",
  "PSI": "Plane Shift: Innistrad",
  "PSK": "Plane Shift: Kaladesh",
  "PSX": "Plane Shift: Ixalan",
  "PSZ": "Plane Shift: Zendikar",
  "PaBTSO;MPP": "Phandelver and Below / Morte's Planar Parade",
  "QFTIS": "Quests from the Infinite Staircase",
  "RMBRE": "The Lost Dungeon of Rickedness: Big Rick Energy",
  "RoT": "Rise of Tiamat",
  "SADS": "Sapphire Dragon Sample",
  "SDW": "Essentials Kit: Sleeping Dragon's Wake",
  "TTP": "The Tortle Package",
  "TftYP": "Tales from the Yawning Portal",
  "ToFW": "Turn of Fortune's Wheel",
  "UATheMysticClass": "Unearthed Arcana: The Mystic Class",
  "VD": "Vecna Dossier",
  "VGtM": "Volo's Guide to Monsters",
  "WBtW": "The Wild Beyond the Witchlight",
  "Xanathar's": "Xanathar's Guide to Everything",
};
